var React = require('react');

function Collision (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.1429 6L31 11V24.75L18.1429 31V6ZM31 11L18.1429 17.25L31 11ZM12.4286 31V6V31ZM12.4286 18.5L3.85714 9.75L12.4286 18.5ZM12.4286 18.5H1H12.4286ZM12.4286 18.5L3.85714 27.25L12.4286 18.5Z","stroke":"url(#paint0_linear_2213_11253)","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_2213_11253","x1":"16.0857","y1":"3.27273","x2":"16.0857","y2":"32.1364","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#8B8ED1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#03045E","key":1})]))]);
}

Collision.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = Collision;

Collision.default = Collision;
